import play from "../../../../svg/play.svg";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";

export default function VideoContainer({
  link,
  titulo,
  descripcion,
  caratula,
}) {
  return (
    <DivScroll className="mb-4">
      <img className="icono-video-noticia" src={play} alt="icono play" />
      <Card bg="light" style={{ width: "19rem", height: "23rem" }}>
        <Card.Img
          variant="top"
          style={{ width: "100%", height: "12rem", objectFit: "cover" }}
          src={caratula}
        />{" "}
        <Card.Body
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card.Title>
            {" "}
            <p className="btn card-title"> {titulo}</p>{" "}
          </Card.Title>
          <Card.Text className="card-text">{descripcion}</Card.Text>
        </Card.Body>
      </Card>
    </DivScroll>
  );
}

const DivScroll = styled.div`
  scroll-snap-align: start;
  position: relative;

  .icono-video-noticia {
    position: absolute;
    width: 5rem;
    top: 5rem;
    left: 7rem;
    z-index: 30;
    cursor: pointer;
  }

  .card-title {
    font-weight: 550;
  }

  .card-text {
    font-weight: 300;
  }
`;
